import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { CommunicationService } from 'src/app/services/communication';
import { Observable, throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { UrlBuilderService } from 'projects/communication/src/app/services/url-builder.service';

@Injectable({
  providedIn: 'root',
})
export class ReportDataService {
  private baseUrl: string;

  constructor(private http: HttpClient, private communicationService: CommunicationService, private urlBuilder: UrlBuilderService) {
    this.baseUrl = this.urlBuilder.serverBasePath;
  }

  /**
   * Function to get messageReportData
   *
   * @param params Parameters
   */
  public getMessageReportData(params: any): Promise<any> {
    const url = `${this.baseUrl}/Report/GetMessageReport`;
    return this.communicationService.get(url, params).toPromise();
  }

  /**
   * Function to get message report Excel
   */
  public getMessageReportExcel(params: any): Observable<any> {
    const url = `${this.urlBuilder.apiUrl}/Report/GetMessageReportDocument`;
    return this.http.get(url, { params, responseType: 'blob' }).pipe(catchError((error) => throwError(() => error.error)));
  }
}
